import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import DeleteIcon from "@mui/icons-material/Delete";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";

import { Loader } from "../../common/loader";
import DialogBox from "../../common/DialogBox";
import { getObjLength } from "../../helpers/utils";
import AlertDialog from "../../common/AlertDialog";
import AddCreditCardForm from "./AddCreditCardForm";
import VisaCard from "../../../assets/dashboard/visa.svg";
import RealEstateAgent from "./RealEstateAgentProperties";
import CommonAgentsAdminTable from "./CommonAgentsAdminTable";
import PlainAlertMessage from "../../common/PlainAlertMessage";
import MasterCard from "../../../assets/dashboard/mastercard.svg";
import DiscoverCard from "../../../assets/dashboard/discover.svg";
import { brokerAgentsAction } from "../../../redux/slices/brokers";
import AmericanCard from "../../../assets/dashboard/american-express.svg";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";
const columns = [
  {
    key: 1,
    label: "Product",
    id: "static",
    staticText: "EP Premium",
    minWidth: 10,
  },
  {
    key: 2,
    label: "Reference",
    id: "receiptNumber",
  },
  {
    key: 3,
    label: "Date",
    id: "date",
  },

  {
    key: 4,
    label: "Amount",
    id: "amount",
  },
  {
    key: 5,
    label: "Status",
    id: "status",
    displayChip: true,
  },
  {
    key: 6,
    label: "",
    id: "invoiceUrl",
    fileDownload: true,
    verify_id: "status",
    verify_Value: "PAID",
  },
];

const BillingPaymentTab = ({ base_route }) => {
  const dispatch = useDispatch();
  const { subscriptionHistory, addSaveCardsData } = useSelector(
    (state) => state?.agentsAdmin
  );
  // store data
  const {
    cardDetails,
    removeCardDetails: removeCardData,
    removedCardLoader,
    cardLoader,
  } = useSelector((state) => state?.userProfile);
  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
  });
  const [openAddCardModal, setOpenAddCardModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isRemoveCardModalOpen, setIsRemoveCardModalOpen] = useState(false);

  const closeAddCardModal = () => {
    setOpenAddCardModal(false);
    dispatch(brokerAgentsAction.fetchAgentPaymentData({}));
    dispatch(agentsAdminAction.fetchAddSaveCardsData(false));
    agentCardListAPICall();
  };
  const removeCard = (cardData) => {
    setSelectedCard(cardData);
    setIsRemoveCardModalOpen(true);
  };

  const handleDeleteCard = () => {
    dispatch(
      userProfileAction.removeNewCard({
        url: `agent/card/${selectedCard?.id}/delete?source=${base_route}`,
        data: {},
        type: "post",
        brokertoken: true,
      })
    );
  };

  const paymentHistoryListAPICall = useCallback(
    (offset = payload?.offset) => {
      let data = {
        limit: payload?.limit,
        offset: offset,
        // domain: broker,
      };
      dispatch(
        agentsAdminAction.getSubscriptionHistoryDetails({
          url: `agent/subscription-history?source=${base_route}`,
          data,
          brokertoken: true,
        })
      );
      window.scrollTo(0, 0);
    },
    [dispatch, payload?.limit, payload?.offset]
  );

  const agentCardListAPICall = () => {
    dispatch(
      userProfileAction.userCardDetails({
        url: `agent/cards?source=${base_route}`,
        data: {},
        brokertoken: true,
      })
    );
  };

  useEffect(() => {
    paymentHistoryListAPICall();
  }, [paymentHistoryListAPICall]);

  useEffect(() => {
    agentCardListAPICall();
  }, []);

  return (
    <div className="billing_wrapper">
      {/* this div is only for to access the Go Premium and User Setting modal and keep hide this div*/}
      <div className="d-none">
        <RealEstateAgent base_route={base_route} isREAgent={true} />
      </div>

      <Grid container spacing={1}>
        <Grid item xs={12} md={7}>
          <Typography className="billing_headers mb-5">
            <span>Billing History</span>
          </Typography>

          <CommonAgentsAdminTable
            columns={columns}
            rowData={
              subscriptionHistory?.success ? subscriptionHistory?.data : []
            }
            tabelMinWidth={0}
            base_route={base_route}
          />
        </Grid>
        <Grid item xs={12} md={0.6}></Grid>
        <Grid item xs={12} md={4.4}>
          <Typography className="billing_headers mb-5">
            <span>Payment Details</span>
          </Typography>
          <Box>
            <Card variant="outlined" sx={{ p: 2, backgroundColor: "#f8fbfd" }}>
              <Stack spacing={2}>
                {getObjLength(cardDetails) && cardDetails?.success ? (
                  cardDetails?.data?.map((card, index) => (
                    <Box key={card.id}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Stack
                          direction="row"
                          spacing={1.8}
                          alignItems="center"
                        >
                          {card.brand === "MasterCard" ? (
                            <img
                              style={{ width: 36, height: 24 }}
                              src={MasterCard}
                              alt="Master Card"
                            />
                          ) : card.brand === "Visa" ? (
                            <img
                              style={{ width: 36, height: 24 }}
                              src={VisaCard}
                              alt="Visa Card"
                            />
                          ) : card.brand === "American Express" ? (
                            <img
                              style={{ width: 36, height: 24 }}
                              src={AmericanCard}
                              alt="American Card"
                            />
                          ) : card.brand === "Discover" ? (
                            <img
                              style={{ width: 36, height: 24 }}
                              src={DiscoverCard}
                              alt="Discover Card"
                            />
                          ) : (
                            <CreditCardIcon fontSize="large" />
                          )}

                          <Typography variant="body1" className="card_data">
                            {card.brand} - **** {card.last4} &nbsp; | &nbsp;
                            {card.exp_month} {card.exp_year}
                            {card.default === 1 && (
                              <Tooltip
                                title="Default card"
                                TransitionComponent={Zoom}
                                arrow
                              >
                                <TaskAltOutlinedIcon color="#25e12f" />
                              </Tooltip>
                            )}
                          </Typography>
                        </Stack>
                        {cardDetails?.data?.length > 1 && (
                          <Tooltip
                            title="Remove card"
                            TransitionComponent={Zoom}
                            arrow
                          >
                            <IconButton
                              sx={{ color: "#FC2125" }}
                              onClick={() => removeCard(card)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        {/* <IconButton size="small">
                          <ArrowForwardIosIcon fontSize="small" />
                        </IconButton> */}
                      </Stack>
                      {index !== cardDetails?.data.length - 1 && (
                        <Divider sx={{ mt: 2 }} />
                      )}
                    </Box>
                  ))
                ) : (
                  <p className="text-danger mb-0">
                    {cardDetails?.data?.message}
                  </p>
                )}
              </Stack>
            </Card>

            <Button
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => setOpenAddCardModal(true)}
              sx={{
                mt: 2,
                color: "#0b60b0",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Add Another Card
            </Button>
          </Box>
        </Grid>
      </Grid>
      {/* Add Office form modal */}
      {openAddCardModal && (
        <DialogBox
          width={"sm"}
          contentClassName={"p-0"}
          openPopup={openAddCardModal}
          setOpenPopup={setOpenAddCardModal}
          closeButtonClass="Zindex__"
          onClose={
            getObjLength(addSaveCardsData) && addSaveCardsData?.success
              ? false
              : closeAddCardModal
          }
          content={
            !getObjLength(addSaveCardsData) || !addSaveCardsData?.success ? (
              <div className="broker-create-account">
                <AddCreditCardForm
                  closeAddCardModal={closeAddCardModal}
                  agentCardListAPICall={agentCardListAPICall}
                  base_route={base_route}
                />
              </div>
            ) : (
              <PlainAlertMessage
                type="Success"
                openPopup={true}
                onClose={true}
                onCloseFun={() => {
                  agentCardListAPICall();
                  closeAddCardModal();
                }}
                message={addSaveCardsData?.message}
                footer={false}
              />
            )
          }
        />
      )}

      {/*  Delete Cards */}
      {isRemoveCardModalOpen ? (
        getObjLength(removeCardData) ? (
          <>
            <AlertDialog
              type={removeCardData?.success ? "Success" : "Error"}
              openPopup={true}
              onClose={true}
              onCloseFun={() => {
                setIsRemoveCardModalOpen(false);
                dispatch(userProfileAction.getRemovedCardDetails({}));
              }}
              mesage={
                removeCardData?.success
                  ? removeCardData?.message
                  : removeCardData?.data?.message
              }
              buttons={
                <>
                  {removeCardData?.success ? (
                    <Button
                      className="popup_Btn success_popup_btn"
                      onClick={() => {
                        setIsRemoveCardModalOpen(false);
                        dispatch(userProfileAction.getRemovedCardDetails({}));
                        agentCardListAPICall();
                      }}
                    >
                      Ok, All Good
                    </Button>
                  ) : (
                    <Button
                      className="popup_Btn error_popup_btn "
                      onClick={() => {
                        setIsRemoveCardModalOpen(false);
                        dispatch(userProfileAction.getRemovedCardDetails({}));
                      }}
                    >
                      Ok, Close
                    </Button>
                  )}
                </>
              }
            />
          </>
        ) : (
          <>
            <AlertDialog
              type="Warning"
              openPopup={true}
              // setOpenPopup={setRemoveCardPopup}
              onCloseFun={() => setIsRemoveCardModalOpen(false)}
              onClose={true}
              loader={removedCardLoader}
              mesage={" Are you sure, you want to delete this card?"}
              buttons={
                <>
                  <Button
                    onClick={() => setIsRemoveCardModalOpen(false)}
                    className="popup_Btn other_popup_btn mx-2"
                    variant="outlined"
                  >
                    Nope
                  </Button>
                  <Button
                    onClick={handleDeleteCard}
                    className="popup_Btn success_popup_btn mx-2"
                    variant="outlined"
                    color="error"
                  >
                    Yes
                  </Button>
                </>
              }
            />
          </>
        )
      ) : null}

      <Loader open={cardLoader} />
    </div>
  );
};

export default BillingPaymentTab;
